module.exports = __webpack_public_path__ + "img/sw4-b3.6dbdfc05.jpg";